import React from "react";
import Chat from "./Chat";

interface ChatModalProps {
  senderEmail: string;
  receiverEmail: string;
  receiverId: string;
  receiverDisplayName: string;
  onClose: () => void;
}

const ChatModal: React.FC<ChatModalProps> = ({
  senderEmail,
  receiverEmail,
  receiverId,
  receiverDisplayName,
  onClose,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <Chat
          senderEmail={senderEmail}
          receiverEmail={receiverEmail}
          receiverId={receiverId}
          receiverDisplayName={receiverDisplayName}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default ChatModal;
